import React, { Component } from "react";
import Unity, { UnityContext } from "react-unity-webgl";
import { withTranslation } from 'react-i18next';
import { faL } from "@fortawesome/free-solid-svg-icons";

class RouletteAnimation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      progression: 0,
      playButton: false,
      WinNo: ''
    };
  }
  toggleSoundOnOff = () => {
    window.playButton = !this.state.playButton;
    this.setState({ playButton: !this.state.playButton });
    window.startbgmusic();
  }
  fnWelcome = (strkey) => {
    document.getElementById("gtrouWinDtlPar").style.display = "none";
    return;
    let tmr = setInterval(() => {
      //let _flog = document.getElementsByClassName("mywebgl");
      //if (_flog != undefined && _flog != null && _flog.length > 0 && _flog[0].style.cursor == "default") {
      if (strkey) {
        //let ssd=_flog.style.cursor;
        clearInterval(tmr);
        //strkey = "ThOtArPuElLaThA~7~12~11/11/11~11:00 AM~Test~2";

        //// this.unityContext.send("roulette table", "WelcomeData", strkey)
        window.writeWinDrawDetails("fnWelcome" + strkey);

        // setTimeout(() => {
        //   this.fnStartAnimation("ThOtArPuElLaThA~12~11/11/11~11:00 AM~Test~2~3:00:00");
        // },5000)

        // setTimeout(() => {
        //   this.fnStartAnimation("ThOtArPuElLaThA~12~11/11/11~11:00 AM~Test~5~3:00:00");
        // },90000)

      }
    }, 1000);

  }
  fnStartAnimation = (strkey) => {
    let WinNo1 = strkey.split("~")[1];
    let wsec = document.getElementById('roultRsltNoAnimate');
    const center1 = document.getElementById('rollEndWindow');
    if (wsec) {
      wsec.style.display = "none";
      center1.style.visibility = '';
    }
    let tmr = setInterval(() => {
      //let _flog = document.getElementsByClassName("mywebgl");//document.getElementsByClassName("mywebgl");
      //if (_flog != undefined && _flog != null && _flog.length > 0 && _flog[0].style.cursor == "default") {
      if (strkey) {
        window.writeWinDrawDetails(strkey);
        clearInterval(tmr);
        //strkey = "ThOtArPuElLaThA~7~12~11/11/11~11:00 AM~Test~2~3:00:00";
        //// this.unityContext.send("roulette table", "rouletteRequestHandler", strkey);
        console.log("fnStartAnimation " + strkey);
        window.myRouletteStart(strkey, () => {
          this.state.WinNo = WinNo1;
          this.moveAnimatiopn();
        });

      }
    }, 1000);
  }

  moveAnimatiopn = () => {
    const center = document.getElementById('rollEndWindow');
    const topRight = document.getElementById('roultRsltNoAnimate');
    setTimeout(() => {
      topRight.style.display = 'block'
      const srcRect = center.getBoundingClientRect();
      const tgtRect = topRight.getBoundingClientRect();

      // Create animated clone
      const clone = center.cloneNode(true);
      clone.style.position = 'fixed';
      clone.style.top = srcRect.top + 'px';
      clone.style.left = srcRect.left + 'px';
      clone.style.width = srcRect.width + 'px';
      clone.style.height = srcRect.height + 'px';
      clone.style.margin = '0';
      clone.style.zIndex = '9999';
      clone.style.transition = 'all 0.9s cubic-bezier(.22,1,.36,1)';
      clone.style.borderRadius = '50%';
      clone.style.pointerEvents = 'none';
      document.body.appendChild(clone);

      // Hide original
      center.style.visibility = 'hidden';

      // Force browser reflow to ensure transition works
      void clone.offsetWidth;

      // Animate to target
      clone.style.top = tgtRect.top + 'px';
      clone.style.left = tgtRect.left + 'px';
      clone.style.width = tgtRect.width + 'px';
      clone.style.height = tgtRect.height + 'px';
      clone.style.borderRadius = '50%';

      // After animation ends
      clone.addEventListener('transitionend', () => {
        // 🎊 FIRE burst from the ORIGINAL rollEndWindow position
        this.triggerWinningAnimation(center);
        clone.remove();
        //center.style.display = 'none';
        topRight.classList.add('show');
      }, { once: true });

    }, 2000);
  }

  triggerWinningAnimation = (fromElement) => {
    const rect = fromElement.getBoundingClientRect();

    const container = document.createElement('div');
    container.classList.add('winning-animation');
    document.body.appendChild(container);

    const colors = ["#ff0", "#0ff", "#f0f", "#0f0", "#f00", "#00f", "#fff"];

    for (let i = 0; i < 200; i++) { // ⬅️ doubled
      const particle = document.createElement('div');
      particle.classList.add('winning-particle');

      const w = 4 + Math.random() * 12;
      const h = 4 + Math.random() * 20;
      particle.style.width = w + "px";
      particle.style.height = h + "px";

      particle.style.background = colors[Math.floor(Math.random() * colors.length)];

      const angle = Math.random() * 2 * Math.PI;
      const distance = 100 + Math.random() * 600;
      const x = Math.cos(angle) * distance + "px";
      const y = Math.sin(angle) * distance + "px";

      particle.style.setProperty("--x", x);
      particle.style.setProperty("--y", y);

      particle.style.top = rect.top + rect.height / 2 + "px";
      particle.style.left = rect.left + rect.width / 2 + "px";

      container.appendChild(particle);
    }    
    window.showInsRouPop();
    //setTimeout(() => container.remove(), 1600);
    setTimeout(() => this.delRouletteBall(container), 1600);
  }
  delRouletteBall = (container) => {
    container.remove();
    if (window.deleteRoulette)
      window.deleteRoulette();
  }
  componentDidMount() {
    if (window.initMyReuletteAni) {
      window.initMyReuletteAni();
    }
    if (window.rotate) {
      window.rotate();
    }

    this.setState({ proCompleted: 0 });
    this.props.fnWelcome(this.fnWelcome);
    this.props.fnStartAnimation(this.fnStartAnimation);
    let sss = this;
    // // this.unityContext.on("progress", function (_prog) {
    // //   sss.setState({progression:_prog});
    // // });
    // this.fnUnityLoaded();

  }
  render() {
    const { t } = this.props;
    return (
      <div class="rouletteWheel">
        <div class="rouletteRsltDtls">
          <div class="rouletteRsltTxt" id="gtrouWinDtlPar" style={{ display: "none" }}>
            <ul id='gtrouWinDtl'>
              {/* <li><p>Name<small>:</small></p><span>-</span></li>
              <li><p>Draw Number<small>:</small></p><span>-</span></li>
              <li><p>Draw Date<small>:</small></p><span>-</span></li>
              <li><p>Draw Time<small>:</small></p><span>-</span></li> */}
            </ul>
          </div>
          <label className={`switch ${this.state.playButton ? 'sound' : ''}`} onClick={() => this.toggleSoundOnOff()}>
            {/* <input type="checkbox" checked={this.state.playButton} onClick={() => this.toggleSoundOnOff()}></input> */}
            <span class="soundSlider round"></span>
            <span id="sound-off-icon">
              <svg class="svg-icon" viewBox="0 0 20 20">
                <path fill="none" d="M3.401,13.367h0.959l1.56-1.56H4.181v-4.07h3.177c0.207,0,0.405-0.084,0.553-0.23l3.608-3.633V6.21l1.56-1.56V1.983c0-0.315-0.192-0.602-0.485-0.721c-0.29-0.122-0.624-0.055-0.85,0.171L7.032,6.178h-3.63c-0.433,0-0.78,0.349-0.78,0.78v5.629C2.621,13.018,2.968,13.367,3.401,13.367z"></path>
                <path fill="none" d="M11.519,15.674l-2.416-2.418L8,14.358l3.745,3.753c0.149,0.149,0.349,0.228,0.553,0.228c0.1,0,0.201-0.019,0.297-0.059c0.291-0.12,0.483-0.405,0.483-0.72V9.28l-1.56,1.56V15.674z"></path>
                <path fill="none" d="M19.259,0.785c-0.167-0.168-0.387-0.25-0.606-0.25s-0.438,0.082-0.606,0.25l-4.968,4.968l-1.56,1.56l-4.496,4.494l-1.56,1.56L0.83,18.001c-0.335,0.335-0.335,0.877,0,1.213c0.167,0.167,0.386,0.251,0.606,0.251c0.22,0,0.439-0.084,0.606-0.251l5.407-5.407l1.105-1.104l2.965-2.966l1.56-1.56l6.18-6.181C19.594,1.664,19.594,1.12,19.259,0.785z"></path>
              </svg>
            </span>
            <span id="sound-on-icon">
              <svg class="svg-icon" viewBox="0 0 20 20">
                <path fill="none" d="M9.344,2.593c-0.253-0.104-0.547-0.045-0.743,0.15L4.486,6.887H1.313c-0.377,0-0.681,0.305-0.681,0.681v4.916c0,0.377,0.304,0.681,0.681,0.681h3.154l4.137,4.142c0.13,0.132,0.304,0.201,0.482,0.201c0.088,0,0.176-0.017,0.261-0.052c0.254-0.105,0.42-0.354,0.42-0.629L9.765,3.224C9.765,2.947,9.599,2.699,9.344,2.593z M5.233,12.003c-0.128-0.127-0.302-0.2-0.483-0.2H1.994V8.249h2.774c0.182,0,0.355-0.072,0.483-0.201l3.151-3.173l0.001,10.305L5.233,12.003z"></path>
                <path fill="none" d="M16.434,10.007c0-2.553-1.518-4.853-3.869-5.858C12.223,4,11.821,4.16,11.672,4.506c-0.148,0.346,0.013,0.746,0.359,0.894c1.846,0.793,3.041,2.6,3.041,4.608c0,1.997-1.188,3.799-3.025,4.592c-0.346,0.149-0.505,0.551-0.356,0.895c0.112,0.258,0.362,0.411,0.625,0.411c0.091,0,0.181-0.017,0.269-0.056C14.922,14.843,16.434,12.548,16.434,10.007z"></path>
                <path fill="none" d="M13.418,10.005c0-1.349-0.802-2.559-2.042-3.086c-0.346-0.144-0.745,0.015-0.894,0.362c-0.146,0.346,0.016,0.745,0.362,0.893c0.737,0.312,1.212,1.031,1.212,1.832c0,0.792-0.471,1.509-1.2,1.825c-0.345,0.149-0.504,0.551-0.352,0.895c0.112,0.257,0.362,0.41,0.625,0.41c0.091,0,0.181-0.017,0.27-0.057C12.625,12.545,13.418,11.339,13.418,10.005z"></path>
                <path fill="none" d="M13.724,1.453c-0.345-0.15-0.746,0.012-0.895,0.358c-0.148,0.346,0.013,0.745,0.358,0.894c2.928,1.256,4.819,4.122,4.819,7.303c0,3.171-1.886,6.031-4.802,7.289c-0.346,0.149-0.505,0.55-0.356,0.894c0.112,0.258,0.362,0.412,0.626,0.412c0.09,0,0.181-0.019,0.269-0.056c3.419-1.474,5.626-4.826,5.626-8.54C19.368,6.282,17.152,2.923,13.724,1.453z"></path>
              </svg>
            </span>
          </label>
          <div class="rouletteRsltNo">
            <div class="roultRsltNoAnimate" id="roultRsltNoAnimate">
              {this.state.WinNo && <><img src="./assets/img/roulette/wheel/winning-bg.png" />
                <span className="txtClrG" style={{ animation: '0.5s ease 0.5s infinite normal none running blinkg' }}>{this.state.WinNo}</span></>}
            </div>
          </div>
        </div>
        <div id="rouletteTable">
          <div id="roulette">
            <div id="roulette4"></div>
            <div id="rouletteShadow"></div>
            <div id="rouletteShadow2"></div>
            <div id="shine"></div>
            <div id="rouletteShadow3"></div>
            <div id="roulette2"></div>
            <div id="roulette6"></div>
            <div id="roulette5">
              <div id="ballSpin">
                <div id="ball"></div>
              </div>
            </div>
          </div>
        </div>

        <div id="money" style={{ display: "none" }}></div>
        <div id="totalBet"></div>
        <div id="totalWin" style={{ display: "none" }}></div>
        <div id="adultTrue"></div>
        <div id="adultFalse"></div>
        <div class="soundText"></div>
        <div class="soundText"></div>
        <div class="soundText"></div>
        <div id="rollEndWindowText"></div>
        <div class="chipsBtn"></div>
        <div class="betComplete" style={{ display: 'none' }}></div>
        <div class="insideFB" style={{ display: 'none' }}></div>
        <div id="startIcon" style={{ display: 'none' }}></div>
        <input type="range" id="dictorVoice" name="dictorVoice" min="0" max="1" step="0.01" value="0.5" style={{ display: 'none' }} />
        <div id="historyMenu" style={{ display: 'none' }}></div>
        <div id="betSection" style={{ display: 'none' }}></div>

        <div id="musicInfo" style={{ display: 'none' }}>
          <i id="vinyl"></i>
          <p id="nowPlaying"></p>
          <button class="changeMusic">
            <i class="fa-solid fa-backward"></i>
          </button>
          <button id="pausePlay">
            <i class="fa-solid fa-pause" id="musicPause"></i>
          </button>
          <button class="changeMusic">
            <i class="fa-solid fa-forward"></i>
          </button>
          <p id="musicTimer"></p>
        </div>
        {/* <div id="rollEndWindow" style={{ animation: 'auto ease 0s 1 normal none running none', transform: 'scale(1)', backgroundColor: 'rgba(0, 0, 0, 0.74)', boxShadow: 'none' }}>
          <div id="rollEndWindowCircle" style={{ animation: 'auto ease 0s 1 normal none running none' }} ></div>
          <p id="rollEndWindowText">Winning<br />Number</p>
          <p id="rollEndWindowNumber">5</p>
          <div id="rollMoneyInfo" style={{ display: 'none' }}></div>
        </div>  */}

        <div id="rollEndWindow">
          <div id="rollEndWindowCircle"></div>
          <p id="rollEndWindowText">Winning<br />Number</p>
          <p id="rollEndWindowNumber">10</p>
          <div id="rollMoneyInfo"></div>
        </div>
        {/* 
        <div>
          <button onClick={() => { window.myRoulette() }}>Load</button>
          <input type="text" id="txtBall" value="ThOtArPuElLaThA~7~12~11/11/11~11:00 AM~Test~6~3:00:00" /> <br />
          <button onClick={() => { window.myRouletteStart() }} >Start</button>
        </div> */}

      </div >
    )
  }

}
export default withTranslation()(RouletteAnimation)

